import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { CustomStarFilled } from '../../config/icons';

interface RatingStarsProps {
  value: number;
}

export const RatingStarsFixed: React.FC<RatingStarsProps> = ({ value }) => {
  return (
    <Flex>
      {Array.from({ length: value }).map((_, i) => (
        <CustomStarFilled key={i} fill="textColor" />
      ))}
    </Flex>
  );
};
